import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { first } from 'rxjs/operators';

declare const google: any;

@Injectable({ providedIn: 'root' })
export class GoogleChartsLoaderService {
	private chartPackage: { [key: string]: string } = {
		AnnotationChart: 'annotationchart',
		AreaChart: 'corechart',
		Bar: 'bar',
		BarChart: 'corechart',
		BubbleChart: 'corechart',
		Calendar: 'calendar',
		CandlestickChart: 'corechart',
		ColumnChart: 'corechart',
		ComboChart: 'corechart',
		PieChart: 'corechart',
		Gantt: 'gantt',
		Gauge: 'gauge',
		GeoChart: 'geochart',
		Histogram: 'corechart',
		Line: 'line',
		LineChart: 'corechart',
		Map: 'map',
		OrgChart: 'orgchart',
		Sankey: 'sankey',
		Scatter: 'scatter',
		ScatterChart: 'corechart',
		SteppedAreaChart: 'corechart',
		Table: 'table',
		Timeline: 'timeline',
		TreeMap: 'treemap',
		WordTree: 'wordtree'
	};

	private googleChartsLoaded: Observable<void>;

	constructor() {
		this.googleChartsLoaded = from(this.loadGoogleCharts());
	}

	private loadGoogleCharts(): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			if (typeof google === 'undefined' || typeof google.charts === 'undefined') {
				const script = document.createElement('script');
				script.src = 'https://www.gstatic.com/charts/loader.js';
				script.onload = () => {
					google.charts.load('45', {
						callback: resolve
					});
				};
				script.onerror = (error) => reject(error);
				document.head.appendChild(script);
			} else {
				resolve();
			}
		});
	}

	load(chartType: string): Observable<void> {
		return new Observable<void>(observer => {
			this.googleChartsLoaded.pipe(first()).subscribe(() => {
				google.charts.load('45', {
					packages: [this.chartPackage[chartType]],
					callback: () => {
						observer.next();
						observer.complete();
					}
				});
			});
		});
	}
}
